module.exports = __webpack_public_path__ + "images/花筑奢pr长图_08-1.jpg?v=1caedcee";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_08-1.jpg
 ** module id = 44
 ** module chunks = 1 2
 **/